<template>
    <div>
        <div class="normalheader ">
            <div class="hpanel">
                <div class="panel-body">
                    <div id="hbreadcrumb" class="pull-right m-t-lg">
                        <ol class="hbreadcrumb breadcrumb">
                            <li>
                                <router-link tag="a" :to="{name:'dashboard'}">Portada</router-link>
                            </li>
                            <li>
                                <span>Usuarios</span>
                            </li>
                            <li class="active">
                                <span>{{ userId ? 'Editar': 'Crear'}} usuario</span>
                            </li>
                        </ol>
                    </div>
                    <h2 class="font-light m-b-xs">
                        {{ userId ? 'Editar': 'Crear'}} usuario
                    </h2>
                    <small>{{ userId ? 'Editar': 'Crear'}} usuario</small>
                </div>
            </div>

        </div>
        <div class="content">
            <div class="hpanel hviolet">
                <div class="panel-heading hbuilt">
                    Usuario
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-lg-3 text-center">
                            <i class="pe-7s-user fa-5x text-muted"></i>
                            <p class="m-t-md">
                                <strong>Usuario</strong> tiene acceso a la aplicación y puede acceder a los diferentes
                                menús de acuerdo al perfil asignado.
                            </p>
                        </div>
                        <div class="col-md-9">
                            <div class="row">
                                <div class="col-md-4 form-group">
                                    <label>Usuario *</label>
                                    <custom-input tipo="text" :field="$v.form.username"/>
                                </div>
                                <div class="col-md-4 form-group">
                                    <label>Contraseña</label>
                                    <custom-input tipo="text" :field="$v.form.password"/>
                                </div>
                                <div class="col-md-4 form-group">
                                    <label>Nombre *</label>
                                    <custom-input tipo="text" :field="$v.form.name"/>
                                </div>
                                <div class="col-md-4 form-group">
                                    <label>Perfil *</label>
                                    <custom-input tipo="select" :field="$v.form.profile" :items="profiles"/>
                                </div>
                                <div class="col-md-4 form-group">
                                    <label>Correo electrónico *</label>
                                    <custom-input tipo="text" :field="$v.form.email"/>
                                </div>
                                <div class="col-md-4 form-group">
                                    <label>Celular *</label>
                                    <custom-input tipo="text" :field="$v.form.phone"/>
                                </div>

                                <div class="col-md-4 form-group"
                                     v-show="form.profile !== null && ['HOTEL'].includes(form.profile.key)">
                                    <label>Hotel</label>
                                    <custom-input tipo="select" :field="$v.form.hotel" :items="hotels"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="text-right">
                        <a class="btn btn-primary" @click="save">Guardar</a>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

    import {USER_EDIT, USER_LIST, USER_NEW} from "../../router/routes";
    import CustomInput from '../common/CustomInput.vue'
    import {alphaNum, email, maxLength, required, requiredIf} from 'vuelidate/lib/validators'
    import {profileList} from '../../util/selectOptions'
    import HotelService from '../../services/HotelService';
    import UserService from '../../services/UserService';
    import Alert from "../../util/alert";

    export default {
        name: USER_EDIT.name,
        props: ['userId'],
        components: {CustomInput},
        data: () => ({
            profiles: profileList,
            hotels: [],
            form: {
                username: null,
                password: null,
                name: null,
                email: null,
                phone: null,
                profile: null,
                hotel: null,
            }
        }),
        watch: {
            userId: function () {
                if (this.userId) {
                    this.clear();
                    this.init(this.userId);
                } else
                    this.clear();
            },
        },
        validations: {
            form: {
                username: {alphaNum, required, maxLength: maxLength(45)},
                name: {required, maxLength: maxLength(100)},
                email: {required, maxLength: maxLength(50), email},
                phone: {required, maxLength: maxLength(20)},
                profile: {required},
                hotel: {
                    required: requiredIf((model) => {
                        return model.profile !== null && model.profile.key === 'HOTEL';
                    })
                },
                password: {
                    required:  requiredIf(function () {
                        return !this.userId;
                    })
                },
            }
        },
        methods: {
            async init() {
                this.hotels = [];
                try {
                    const hotelsData = (await HotelService.listAllHotels()).data.payload;
                    hotelsData.forEach(it => {
                        this.hotels.push({key: it.id, value: it.name})
                    });
                    if (this.userId) {
                        const user = (await UserService.getUser(this.userId)).data.payload;
                        this.load(user);
                    }
                } catch (err) {
                    Alert.mensajeError(err.message);
                    this.$router.push({path: USER_NEW.route});
                }
            },
            load(user) {
                this.form.username = user.username;
                this.form.name = user.name;
                this.form.email = user.email;
                this.form.phone = user.phone;
                this.form.profile = this.profiles.filter((o) => {
                    return o.key === user.profile;
                })[0];

                if(user.hotel){
                    this.form.hotel = this.hotels.filter((o) => {
                        return o.key === user.hotel.id;
                    })[0];
                }
            },
            async save() {
                this.$v.$touch();
                if (this.$v.$error) return;
                const self = this;

                const data = {
                    ...self.form, ...{
                        profile: self.form.profile ? self.form.profile.key : null,
                        hotelId: self.form.hotel ? self.form.hotel.key : null
                    }
                };
                try {
                    if (self.userId) {
                        const userUpdated = (await UserService.updateUser(self.userId, data)).data.payload;
                        self.load(userUpdated);
                        Alert.mensajeExito("Usuario actualizado.");
                        self.$router.push({path: USER_LIST.route});
                    } else {
                        await UserService.addUser(data);
                        Alert.mensajeExito("Se enviará un correo electrónico con el link para que el nuevo usuario genere una contraseña");
                        self.clear();
                        self.$router.push({path: USER_LIST.route});
                    }
                    self.$v.$reset();
                } catch (err) {
                    Alert.mensajeError(err.message);
                }
            },
            clear() {
                const self = this;
                self.form.username = self.form.name = self.form.email = self.form.profile = self.form.hotel = null;
                self.form.phone = '';
            }
        },
        mounted() {
            this.init();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/user/UserEditor.vue